<div class="row">
    <div class="col-xs-12">
        <div class="card card-block card--box card--box--dashboard card--box--dashboard__item">
            <div class="mx-auto card--box--dashboard__item__header">
                <h2>
                    {{ 'Most common stresses' | translate }}
                    <span>
                        <i class="fal fa-info-circle"
                           aria-hidden="true"
                           tooltip="{{'Most frequent stresses which have been estimated by the therapists' | translate}}"
                           containerClass="tooltip-study"
                           placement="top"></i>
                    </span>
                </h2>
            </div>
            <div class="mx-auto card--box--dashboard__item__filter">
                <div class="row form-group">
                    <div class="col-xs-2 mr-t--md" *ngFor="let gender of genders">
                        <input type="radio"
                               [checked]="filterParams['gender'] == gender.value"
                               [value]="gender.value"
                               name="gender"
                               id="gender-{{gender.value}}"
                               (change)="setFilterGender($event)" />
                        <label for="gender-{{gender.value}}">{{ gender.name | translate }}</label>
                    </div>
                    <div class="col-xs-2 mr-t--md text-right">
                        {{ 'Age range' | translate }}
                    </div>
                    <div class="col-xs-2 age--select">
                        <div class="form-group mat-select-pill">
                            <mat-select class="mat-select-pill__select" [placeholder]="'Age range' | translate"
                                        [(ngModel)]="filterAge"
                                        (ngModelChange)="setFilterAge()">
                                <mat-option *ngFor="let age of ageRange" [value]="age">
                                    {{ age[0] | translate }}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mx-auto card--box--dashboard__item__filter card--box--dashboard__item__filter__mobile">
                <div class="row form-group">
                    <div class="col-xs-12 p-0 mr-t--xs">
                        <div class="form-group mat-select-pill">
                            <mat-select class="mat-select-pill__select" [placeholder]="'Gender' | translate"
                                        [(ngModel)]="filterGender"
                                        (ngModelChange)="setFilterGender($event)">
                                <mat-option *ngFor="let gender of genders" [value]="gender">
                                    {{ gender.name | translate }}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>
                    <div class="col-xs-12 p-0 mr-t--xs">
                        <div class="form-group mat-select-pill">
                            <mat-select class="mat-select-pill__select" [placeholder]="'Age range' | translate"
                                        [(ngModel)]="filterAge"
                                        (ngModelChange)="setFilterAge()">
                                <mat-option *ngFor="let age of ageRange" [value]="age">
                                    {{ age[0] | translate }}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="data; else noData">
                <div class="card card--box--dashboard__item__block mental-check mr-t--md">
                    <div *ngFor="let domain of data" class="row common-strains mr-t--sm">
                        <div class="col-sm-3 col-xs-12 d-flex common-strains__label">
                            <span class="doman-percent">
                                {{domain['total_percent']}}%
                            </span>
                            <span class="domain-text">
                                {{ domain['name_' + activeLanguage] | translate}}
                            </span>
                        </div>
                        <div class="col-sm-9 col-xs-12 d-flex common-strains__chart">
                            <div class="common-strains__chart__bar">
                                <span class="common-strains__chart__bar__item low" tooltip="{{domain['low']}}% {{ 'Light impairment' | translate}}" style.width="{{domain['low']}}%"></span>
                                <span class="common-strains__chart__bar__item medium" tooltip="{{domain['medium']}}% {{ 'Middle impairment' | translate}}"  style.width="{{domain['medium']}}%"></span>
                                <span class="common-strains__chart__bar__item high" tooltip="{{domain['high']}}% {{ 'Severe impairment' | translate}}"  style.width="{{getPercentage(domain)}}%"></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-3 col-xs-12 offset-sm-3 d-flex common-strains__legend">
                        <div class="d-flex align-items-center">
                            <span class="color low"></span>
                        </div>
                        <div class="col-xs-9">
                            <span class="common-strains__col__title">
                                {{ 'Light impairment' | translate}}
                            </span>
                        </div>
                    </div>
                    <div class="col-sm-3 col-xs-12 d-flex common-strains__legend">
                        <div class="d-flex align-items-center">
                            <span class="color middle"></span>
                        </div>
                        <div class="col-xs-9">
                            <span class="common-strains__col__title">
                                {{ 'Middle impairment' | translate}}
                            </span>
                        </div>
                    </div>
                    <div class="col-sm-3 col-xs-12 d-flex common-strains__legend align-items-end">
                        <div class="d-flex">
                            <span class="color high"></span>
                        </div>
                        <div class="col-xs-9">
                            <span class="common-strains__col__title">
                                {{ 'Severe impairment' | translate}}
                            </span>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #noData>
                <div class="card card--box--dashboard__item__block mental-check mr-t--md text-center mental-check-error-message">
                    {{ message | translate}}
                </div>
            </ng-template>
        </div>
    </div>
</div>